import React from 'react';
import { createIcon } from 'native-base';
import { Path } from 'react-native-svg';
export const CircleOutlineIcon = createIcon({
    viewBox: '0 0 28 29',
    path: (React.createElement(Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 14.5C4.25 19.8848 8.61522 24.25 14 24.25C19.3848 24.25 23.75 19.8848 23.75 14.5C23.75 9.11522 19.3848 4.75 14 4.75C8.61522 4.75 4.25 9.11522 4.25 14.5ZM22.25 14.5C22.25 19.0563 18.5563 22.75 14 22.75C9.44365 22.75 5.75 19.0563 5.75 14.5C5.75 9.94365 9.44365 6.25 14 6.25C18.5563 6.25 22.25 9.94365 22.25 14.5Z", fill: "currentColor" })),
});
